module.exports = __webpack_public_path__ + "static/media/briefcase.22483062.svg";